import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';

export function notify(options) {
  const {
    message,
    localeStrings,
    icon,
    type,
  } = options;

  EventBus.$emit('renderGlobalMessage', {
    message: i18n.t(message, localeStrings),
    icon,
    type,
  });
}

export function notifySuccess(message, localeStrings = {}) {
  notify({
    message,
    localeStrings,
    icon: 'check',
    type: 'success',
  });
}

export function notifyError(message, localeStrings = {}) {
  notify({
    message,
    localeStrings,
    icon: 'times',
    type: 'error',
  });
}
